import React from 'react';

import { DEEPFAKE_STATE_OPTIONS } from '@vlabs/api-bindings/src/constants';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CheckboxCustomFilter } from '../components/checkbox-custom-filter/CheckboxCustomFilter';
import { CustomFilterPopover } from '../components/CustomFilterPopover';
import { useFilterCount } from '../hooks';

export const DeepfakeCheckboxesPopover = ({ onCountChange = undefined }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const selectedDeepfake = useWatch({ name: 'deepfake' });
  const filterCount = Array.isArray(selectedDeepfake) && selectedDeepfake.length > 0 ? 1 : 0;
  useFilterCount('deepfake', filterCount, onCountChange);

  return (
    <CustomFilterPopover
      hasFilterValue={Boolean(filterCount)}
      testId="deepfakeFilter"
      triggerValue={t('deepfake')}
    >
      <CheckboxCustomFilter
        control={control}
        isMulti
        name="deepfake"
        options={DEEPFAKE_STATE_OPTIONS.raw}
      />
    </CustomFilterPopover>
  );
};
